import { LazyModule } from 'owa-bundling';

// TODO: VSO #88707 Separate module vs surface concerns in Calendar module
// This package should be broken up so that orchestrators are better organized
// with respect to their associated features
//
// Additionally, compose orchestration should be moved to common compose packages
// rather than specific/unique to Calendar module

export const lazyCalendarOrchestrationModule = new LazyModule(
    () => import(/* webpackChunkName: "CalendarModuleOrchestration" */ './lazyIndex')
);
